<template>
  <f-form
    store="@freebe/entrepreneurs"
    :id="id"
  >
    <template #default="{ item }">
      <div class="is-grid">
        <f-field 
          class="is-col-3"
          label="Type"
        >
          <f-input 
            v-model="item.activity.type"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Statut"
        >
          <f-input 
            v-model="item.activity.status"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Déclaration"
        >
          <f-select 
            v-model="item.activity.declaration"
            :options="declarationOptions"
            :readonly="!canEdit"
            label="label"
            value="value"
            long
          >
            <template #header>
              {{ declarationFrequency }}
            </template>
          </f-select>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Code APE"
        >
          <f-input 
            v-model="item.activity.ape"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-12"
          label="Intitulé APE"
        >
          <f-input 
            v-model="item.activity.speciality"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-12"
          label="RCS"
        >
          <f-input 
            v-model="item.activity.rcs"
            :readonly="!canEdit"
          ></f-input>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useConstantsWording from '@composables/use-constants'
  import useRoles from '@composables/use-roles'
  
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
    },

    setup (props) {
      const { get } = useStore('@freebe/entrepreneurs')
      const wording = useConstantsWording()
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/entrepreneurs:patch')
      )

      const entrepreneur = computed(() =>
        get(props.id)
      )

      const declarationFrequency = computed(() => 
        wording.entrepreneurs.declaration.find((type) => 
          type.value === entrepreneur.value.activity.declaration
        ).label
      )

      return {
        declarationFrequency,
        declarationOptions: wording.entrepreneurs.declaration,
        canEdit,
      }
    },
  }
</script>